<template>
  <div v-if="company && qualification">

    <strong><SubHeader title="Current Status" /></strong>

    <b-row class="my-1">
      <b-col md="3" class="label">
        <label :for="'clientStatusId' + index"> Client Status </label>
      </b-col>
      <b-col md="9">
       <b-form-select
          :id="'clientStatusId' + index"
          v-model="qualification.clientStatusId"
          :disabled="qualification.id == 0"
          
          
        >
          <b-form-select-option :value="0">Undecided</b-form-select-option>
          <b-form-select-option :value="1" :disabled="qualification.contractSentDate == null">Client Won</b-form-select-option>
          <b-form-select-option :value="2" :disabled="qualification.contractSentDate == null">Contract Sent</b-form-select-option>
          <b-form-select-option :value="3">Client Lost</b-form-select-option>
          <b-form-select-option :value="4">Client Dropped</b-form-select-option>
        </b-form-select>
      </b-col>
    </b-row>

    <b-row class="my-1"  v-if="qualification.clientStatusId == 4"  id="droppedReasonRow" >
          <b-col md="3" class="label">
            <label :for="'droppedReasonID' + index"> Dropped Reason </label>
          </b-col>
          <b-col md="9">
            <b-form-select
              :id="'droppedReasonID' + index "
              v-model="qualification.droppedReasonID"
              :options="droppedReason"
              value-field="id"
              text-field="name"
            >
              <template v-slot:first>
                <b-form-select-option :value="null" >-</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
    </b-row>

    <b-row class="my-1" hidden>
      <b-col md="3" class="label">
        <label :for="'ElicitationDate' + index">
          Elicitation Complete?
        </label>
      </b-col>
      <b-col md="9">
        <b-form-datepicker :id="'ElicitationDate' + index"
        :date-format-options="{
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        }"
        locale="en-GB"
        v-model="qualification.elicitationDate"
        ></b-form-datepicker>
      </b-col>
    </b-row>

     <SubHeader title="Contract Information" />
     
    <b-row class="my-1">
      <b-col md="3" class="label">
        <label :for="'contractSignedDate' + index">
          Date Contract Signed by client
        </label>
      </b-col>
      <b-col md="9">
        <b-form-datepicker :id="'contractSignedDate' + index"
        :date-format-options="{
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        }"
        locale="en-GB"
        v-model="qualification.contractSignedDate"
        :disabled="qualification.id == 0 "></b-form-datepicker> 
      </b-col>
    </b-row>

    <b-row class="my-1">
          <b-col md="3" class="label">
            <label :for="'commisionAgreed' + index "> % commission agreed </label>
          </b-col>
          <b-col md="9">
            <b-form-input
              :id="'commisionAgreed' + index "
              type="number"
              step="0.01"
              v-model="qualification.commisionAgreed"></b-form-input>
          </b-col>
      </b-row>

    <b-row class="my-1">
          <b-col md="3" class="label">
            <label :for="'contractLength' + index "> Contract length (years) </label>
          </b-col>
          <b-col md="9">
            <validation-provider
              name="Contract length (years)"
              :rules="{ integer: true }"
              v-slot="validationContext"
            >
              <b-form-input
                :id="'contractLength' + index "
                type="number"
                step="1"
                :state="getValidationState(validationContext)"
                v-model="qualification.contractLength"></b-form-input>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </validation-provider>
          </b-col>
        </b-row>

    <b-row class="my-1">
          <b-col md="3" class="label">
            <label :for="'expectYearsForFirstClaim' + index "> Expected number of years for first claim </label>
          </b-col>
          <b-col md="9">
            <b-form-input
              :id="'expectYearsForFirstClaim' + index "
              v-model="qualification.expectYearsForFirstClaim"></b-form-input>
          </b-col>
        </b-row>

    <b-row class="my-1">
      <b-col md="3" class="label">
        <label :for="'termsOfContract' + index">
          Detail of Terms
        </label>
      </b-col>
      <b-col md="9">
        <b-form-textarea :id="'termsOfContract' + index"
        v-model="qualification.termsOfContract"
        rows="3"
        :disabled="qualification.id == 0"></b-form-textarea>
      </b-col>
    </b-row>

    <b-row class="my-1">
          <b-col md="3" class="label">
            <label :for="'yearEnd' + index "> Client year end </label>
          </b-col>
          <b-col md="9">
            <validation-provider
              name="yearEnd"
              :rules="{ integer: true, max_value:maxYear() }"
              v-slot="validationContext"
            >
              <b-form-input
              :id="'yearEnd' + index "
              type="number"
              :state="getValidationState(validationContext)"
              v-model="qualification.yearEnd"
              >
              </b-form-input>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </validation-provider>
          </b-col>
        </b-row>

    <b-row class="my-1">
          <b-col md="3" class="label">
            <label :for="'yearEndMonth' + index"> Year end month </label>
          </b-col>
          <b-col md="9">
            <b-form-select
              :id="'yearEndMonth' + index "
              v-model="qualification.yearEndMonth"
              :options="months"
              value-field="id"
              text-field="name"
            >
              <template v-slot:first>
                <b-form-select-option :value="null" >-</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
    <br>
    <SubHeader title="" />

    <b-row class="my-1">
      <b-col md="3" class="label">
        <label :for="'isMainContactResponsibleForClaim' + index">
          Person Responsible
        </label>
      </b-col>
      <b-col md="9">
        <b-form-radio
          v-model="qualification.isMainContactResponsibleForClaim"
          name="some-radios"
          :value="true"
          :disabled="qualification.id == 0">Main Contact</b-form-radio>
        <b-form-radio
          v-model="qualification.isMainContactResponsibleForClaim"
          name="some-radios"
          :value="false"
          :disabled="qualification.id == 0">Other</b-form-radio>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3" class="label">
        <label :for="'responsibleForClaimFullName' + index">
          Full name
        </label>
      </b-col>
      <b-col md="9">
        <b-form-input :id="'responsibleForClaimFullName' + index"
        v-model="qualification.responsibleForClaimFullName"
        :disabled="qualification.id == 0"></b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3" class="label">
        <label :for="'responsibleForClaimPosition' + index">
          Position
        </label>
      </b-col>
      <b-col md="9">
        <b-form-input :id="'responsibleForClaimPosition' + index"
        v-model="qualification.responsibleForClaimPosition"
        :disabled="qualification.id == 0"></b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3" class="label">
        <label :for="'responsibleForClaimEmail' + index">
          Email
        </label>
      </b-col>
      <b-col md="9">
        <b-form-input :id="'responsibleForClaimEmail' + index"
        v-model="qualification.responsibleForClaimEmail"
        :disabled="qualification.id == 0"
        type="email"></b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3" class="label">
        <label :for="'responsibleForClaimTelephone' + index">
          Tel
        </label>
      </b-col>
      <b-col md="9">
        <b-form-input :id="'responsibleForClaimTelephone' + index"
        v-model="qualification.responsibleForClaimTelephone"
        :disabled="qualification.id == 0"></b-form-input>
      </b-col>
    </b-row>

    <div v-for="(claim, claimIndex) in claims" :key="claim.id">
      <ClientClaim :index="parseInt(index)" :claimIndex="parseInt(claimIndex)" :claim="claim" :key="claim_reload" :claimStatuses="lookups.claimStatuses"></ClientClaim>
    </div>

    <b-button @click="addBlankClaim">Add new Claim</b-button>

    <b-row>
      <br>
    </b-row>

    <SubHeader title="" />

    <b-row class="my-1">
      <b-col md="3" class="label">
        <label :for="'finalInvoiceValue' + index">
          Final Invoice Value
        </label>
      </b-col>
      <b-col md="9">
            <b-input-group>
              <b-input-group-prepend is-text>
                £
              </b-input-group-prepend>
                
                <b-form-input
                  :id="'finalInvoiceValue' + index"
                  type="number"
                  step="0.01"
                  
                  v-model="qualification.finalInvoiceValue"
                  class="CurrencyClaimDisplay"
                  disabled
                  ></b-form-input>
            </b-input-group>
        
            
        </b-col>
      
    </b-row>

    <b-row class="my-1">
      <b-col md="3" class="label">
        <label :for="'dateInvoiceSettled' + index">
          Date Invoice Settled
        </label>
      </b-col>
      <b-col md="9">
        <b-form-datepicker :id="'dateInvoiceSettled' + index"
        :date-format-options="{
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        }"
        locale="en-GB"
        v-model="qualification.dateInvoiceSettled"
        :disabled="qualification.id == 0"></b-form-datepicker>
      </b-col>
    </b-row>

    

    <b-row class="my-1">
      <b-col md="3"></b-col>
      <b-col md="9">
        <b-button type="submit" variant="success" class="margin-right"  @click="save" :disabled="qualification.id == 0">
          <font-awesome-icon icon="save" /> Save
        </b-button>
        <!-- <b-button type="submit" variant="success" class="margin-right"  >
          <font-awesome-icon icon="save" /> Save and Send to Director
        </b-button> -->
        <FeedbackButton class="margin-right"
          title="Save and Send to Director"
          icon="save" :busy="isBusy"
          :onClick="saveAndSend"
          :disabled="qualification.id == 0"/>

        <b-button type="reset" variant="danger" @click="reset" :disabled="qualification.id == 0">
          <font-awesome-icon icon="times" /> Cancel Changes
        </b-button>
      </b-col>
    </b-row>
    <b-row class="my-1">
      <b-col md="3">
      </b-col>
      <b-col md="6">
        <Feedback ref="saveFeedback"/>
      </b-col>
    </b-row>
    <ClientLostReasonModal ref="clientLostReasonModal" :save="save2"/>
  </div>
</template>

<script>
import SubHeader from "@/components/shared/SubHeader.vue";
import CompanyService from '@/services/Company.service'
import Feedback from "@/components/shared/Feedback.vue";
import FeedbackButton from "@/components/shared/FeedbackButton.vue";
import ClientLostReasonModal from "@/components/company/client/ClientLostReasonModal.vue";
import ClientClaim from "@/components/company/client/ClientClaim.vue";

export default {
  components: { SubHeader, Feedback, ClientLostReasonModal, ClientClaim, FeedbackButton },
  props: {
    company: Object,
    initialQualification: Object,
    lookups: Object,
    index: Number
    },
    mounted() {
      if (this.initialQualification && this.qualification == null) {
        this.setQualification()
        this.setClaims()
        this.finalInvoiceValue()
      }
      this.setDefaultfullCommissionAmountExpected();
    },  
  watch: {
    claims: {
      handler() {
        //claim_reload++ //rerender component
      }
    },
    initialQualification: {
      handler(newValue, oldValue) {
        const diff = {};
        Object.keys(newValue).forEach(key => {
          if (!Object.is(oldValue[key], newValue[key])) {
            diff[key] = newValue[key];
          }
        });
      },
      deep: true  
  },
    initialCompany: function() {
      //this.qualification = {...this.initialQualification};
     //this.setClaims();     
      //this.finalInvoiceValue()
    },
    clientStatusId: function (){    
    }
  },
  data() {
    return {
      isBusy: false,
      qualification: null,
      wonStatusLossWin: [
        {value: 0, text: "Undecided" },
        {value: 1, text: "Client Won" },
        {value: 2, text: "Contract Sent" },
        {value: 3, text: "Client Lost" },
        {value: 4, text: "Client Dropped" },
      ],
      wonStatusLoss: [
        {value: 0, text: "Undecided" },
        {value: 3, text: "Client Lost" },
      ],
      months: [
        { id: 1, name: "January"},
        { id: 2, name: "February"},
        { id: 3, name: "March"},
        { id: 4, name: "April"},
        { id: 5, name: "May"},
        { id: 6, name: "June"},
        { id: 7, name: "July"},
        { id: 8, name: "August"},
        { id: 9, name: "September"},
        { id: 10, name: "October"},
        { id: 11, name: "November"},
        { id: 12, name: "December"}
      ],
      droppedReason: [
        { id: 10, name: "No(t) Enough R&D"},
        { id: 20, name: "Client Not Responding"},
        { id: 30, name: "Client Changed Mind"},
        { id: 40, name: "Competitor"},
        { id: 50, name: "Gone out of business"},
        { id: 60, name: "Other"}
      ],
      claims: [],
      claim_reload: 0,
    }
  },
  computed: {
    wonStatus() {
      if (this.qualification) {
        return this.wonStatusLossWin;
      } else {
        return this.wonStatusLoss;
      }
    },
  },
  methods: {
    reset() {     
      if (this.initialQualification) {
        this.setQualification()
        this.setClaims()
        this.claim_reload++; //tell component to re-render
      }     
    },
    setQualification() {
      this.qualification = JSON.parse(JSON.stringify(this.initialQualification))//hack method to make deep copy of initialQualification because spreader operator doesn't work
    },
    setClaims() {
      if (this.qualification.companyRandDQualificationClaims && this.qualification.companyRandDQualificationClaims.length != 0) {
        this.claims = this.qualification.companyRandDQualificationClaims   
      }
      else {
        this.addBlankClaim();
      }
    },
    finalInvoiceValue() {
      if (!this.qualification || !this.claims || this.claims.length == 0) {
        return 0;
        
      }
      var total = 0;
      for(var claim of this.claims) {
        var value = claim.feeReceived;
        if(!value) value = 0;
         total += parseFloat(value);
      }
      
      this.qualification.finalInvoiceValue = total;
      //document.getElementById("finalInvoiceValue0").value = finalNewValue;
      //document.getElementById("finalInvoiceValueDisplay0").value = formattedNewValue;
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    setDefaultfullCommissionAmountExpected(){
      for(var claim of this.claims) {
        if (!claim.fullCommissionAmountExpected)
        claim.fullCommissionAmountExpected = 3500;
      }
    },
    maxYear() {
      var date = new Date();
      return date.getFullYear() + 10;
    },
    SaveCurrencyInputs()    {
      var elements = document.getElementsByClassName("CurrencyClaimDisplay");
      for (let element of elements) {
          var stringElement = element.id;
         document.getElementById(stringElement).dispatchEvent(new Event('input'));
      }     
    },
    save() {
      this.SaveCurrencyInputs();
      this.finalInvoiceValue();
      this.isBusy = true;
      this.setDroppedReason();
      if (this.initialQualification.clientStatusId != 3 && this.qualification.clientStatusId == 3) { //now marked as lost, so show message
        this.$refs.clientLostReasonModal.showModal()
      }
      else {
        CompanyService.saveCompanyQualifications(this.qualification).then(() => {
          this.$refs.saveFeedback.showSuccess("Save Successful");
          this.isBusy = false;
          setTimeout(() => { this.$parent.$parent.$parent.$parent.$parent.loadData() }, 2000);
          this.$parent.$parent.$parent.$parent.$parent.reloadQualificationData();
        })
        .catch(() => {
          this.$refs.saveFeedback.showError("Error", "Unable to save");
          this.isBusy = false;
        })
      }
      
    },    
    setDroppedReason(){
      
      if(this.qualification.clientStatusId != 4)
      {
        this.qualification.droppedReasonID = "";
      }
      
    },
    saveAndSend() {
      this.SaveCurrencyInputs();
      this.isBusy = true;
      this.setDroppedReason();
      if (this.initialQualification.clientStatusId != 3 && this.qualification.clientStatusId == 3) { //now marked as lost, so show message
        this.$refs.clientLostReasonModal.showModal()
      }
      else {
        CompanyService.saveAndSendCompanyQualification(this.qualification).then(() => {
          this.$refs.saveFeedback.showSuccess("Save Successful");
          this.isBusy = false;
          setTimeout(() => { this.$parent.$parent.$parent.$parent.$parent.loadData() }, 2000);
        })
        .catch(() => {
          this.$refs.saveFeedback.showError("Error", "Unable to send email");
          this.isBusy = false;
        })
      }      
    },
    addBlankClaim() {
      if (this.qualification.companyRandDQualificationClaims == null) this.qualification.companyRandDQualificationClaims = [];

      var newItem = {
        FullCommissionAmountExpected:3500,
        HMRCProcessedValue: null,
        DateSubmittedToHMRC: null,
        ExpectedSubmissionDate: null,
        DatePaid: null,
        FeeReceived: null,
        LastChasedDate: null,
        ClaimNotes: null,
        AwardExpectedToClient: null
      };

      this.qualification.companyRandDQualificationClaims.splice(this.qualification.companyRandDQualificationClaims.length,1,  newItem)
      this.claims = this.qualification.companyRandDQualificationClaims;
      this.setDefaultfullCommissionAmountExpected();
    },
    save2(lostReason) {
      this.isBusy = true;
      this.qualification.clientLostreason = lostReason;
      CompanyService.saveCompanyQualifications(this.qualification).then(() => {
        this.$refs.saveFeedback.showSuccess("Save Successful");
        this.isBusy = false;
        this.$parent.$parent.$parent.$parent.$parent.loadData();
      })
      .catch(() => {
        this.$refs.showError.showSuccess("Error", "Unable to save");
        this.isBusy = false;
      })
    }
  }
};
</script>

<style scoped>
  .label {
    text-align: right;
  }
  .label > label {
    margin-top: 6px;
  }
</style>
